import { Component, OnInit } from '@angular/core';
import { TopMenuService, MenuItem } from '../services/top-menu.service';
import { AppSettings } from '../../core';

@Component({
    selector: 'sm-nav-menu-footer',
    template: require('./sm-nav-menu-footer.component.html')
})
export class SmNavMenuFooterComponent implements OnInit {
    menuItems: MenuItem[] = [];

    public readonly AUKRO_URL = AppSettings.AUKRO_URL;

    constructor(private _topMenuService: TopMenuService) { }

    ngOnInit() {
        this._topMenuService
            .getMenu('bottom')
            .subscribe(items => this.menuItems = items || []);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-nav-menu-footer.component.ts